var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.69 17s-1.218-2.449-1.397-2.917A1.681 1.681 0 0019.569 13h-7.138a1.68 1.68 0 00-1.724 1.083C10.527 14.55 9.31 17 9.31 17A1.735 1.735 0 008 18.698V23h1v.8a1.234 1.234 0 002.467 0V23h9.066v.8a1.234 1.234 0 002.467 0V23h1v-4.302A1.738 1.738 0 0022.69 17zm-12.073 3.87a1.082 1.082 0 01-1.099-1.052 1.107 1.107 0 011.1-1.083 1.082 1.082 0 011.07 1.083 1.057 1.057 0 01-1.06 1.053zm.148-3.87l1.102-2.481a.75.75 0 01.506-.519h7.254a.754.754 0 01.506.519l1.1 2.481zm10.618 3.87a1.057 1.057 0 01-1.07-1.042v-.01a1.07 1.07 0 012.14-.025v.025a1.058 1.058 0 01-1.064 1.053zM20.168 7.125h-4.587a2.505 2.505 0 10.214 2.356h.92l.133-.16.562-.535.537.535.562-.535.563.535.534-.535.563.535.83-.83v-.483zm-7.515 2.031a.653.653 0 11.652-.652.653.653 0 01-.652.652z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--rental-car-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'RentalCarCircleIcon';
export default Icon;